import React from 'react'

import { Absolute, Relative } from '../helpers/Position'
import { hasValue } from '../../../../utils/helpers/value'
import { useFieldValue } from './form/FormHandler'
import IconText from '../presentation/IconText'
import Panel from '../structure/Panel'
import Select from './Select'

const DropdownWithInput = ({
  field,
  path,
  label,
  value: valueFromProps,
  Input: CustomInput,
  onChange,
  disableCloseOnChange,
  disableCloseOnBlur,
  bold,
  color,
  position,
  dropdownWidth,
  ...props
}) => {
  const [isEditing, setIsEditing] = React.useState(false)
  const onClose = () => setIsEditing(false)
  const handleKeyUp = e => e.code === 'Escape' && onClose()

  let [value, error] = useFieldValue({ field, path })
  value = valueFromProps || value

  CustomInput = CustomInput || Select

  return (
    <Relative zIndex="auto">
      <IconText
        label={label}
        iconRight="BsFillCaretDownFill"
        iconSize={0.6}
        gutter={0.3}
        color={color}
        onClick={() => setIsEditing(true)}
        size={props.size}
        bold={hasValue(bold) ? bold : true}
      />
      {isEditing && (
        <Absolute right={position === 'right' && 0}>
          <Panel width={dropdownWidth} padding={0.2}>
            <CustomInput
              size="small"
              autoFocus
              onKeyUp={handleKeyUp}
              onBlur={!disableCloseOnBlur ? () => setTimeout(onClose, 200) : undefined}
              value={value}
              onChange={v => {
                onChange(v)
                if (!disableCloseOnChange) onClose()
              }}
              disableEmptyOption
              onClose={onClose}
              {...props}
            />
          </Panel>
        </Absolute>
      )}
    </Relative>
  )
}

export default DropdownWithInput
